<template >
	
	<v-dialog slot="activator" v-model="dialog" persistent max-width="500">
        <v-btn slot="activator" icon>
        	<v-icon color="grey darken-2">add_circle_outline</v-icon>
        </v-btn>
        <v-card >
        	<v-toolbar><v-toolbar-title>
        		ADD PRINCIPAL INVESTIGATOR
        	</v-toolbar-title></v-toolbar>
         	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-1 pt-2">
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Dept:</v-flex>
	         				<v-flex>{{deptPCT.deptName}}</v-flex>
	         			</v-layout>
	         		</v-flex>
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Room:</v-flex>
	         				<v-flex v-if="room">{{room.number}}</v-flex>
         				</v-layout>
         			</v-flex>
         		</v-layout>
         	</v-card-title> 
        	<v-card-text class="pb-5">
				<EmployeeAutocomplete v-on:return-employee="setEmployee" :soloinverted="true" :key="reset"/>
			</v-card-text>
        	<v-card-actions>
	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="dialog=false">Cancel</v-btn>
	          	<v-btn color="green darken-1" flat @click.native="addPI">Add
	      	 	 </v-btn>
	        </v-card-actions>
    	</v-card>
    </v-dialog>
    
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'
import { AUTH_COOKIE } from '@/store/modules/user'
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'

	export default {
		data: () => ({
			employee: null,
			checkbox: false,
			loading: false,
			items: [],
			search: null,
			dialog: false,
			reset: 1, 			// This is used to reset the employee autocomplete child component
		}),

		components: { EmployeeAutocomplete },

		props: [ 'deptPCT' ],

		computed: {
				...mapState({ room: state => state.space.selectedRoom, }),
		},

		methods: {
			...mapMutations(['setSnackText']),
			...mapActions(['insertPI', 'fetchFullRoom']),

			setEmployee(value) {
				this.employee = value
			},
			

			addPI () {
				if (!this.employee) { return }
				const payload = { key: this.deptPCT.key, employeeID: this.employee.employeeID, current: true}
				this.insertPI(payload)
				.then((response) => {
					// If the response is not data, put it on Snack
					!typeof response[0] == 'object' && this.setSnackText(response) 
					// reset and refresh things
					this.$emit('updateLoading', true)
					this.$emit('success')
					this.reset=this.reset + 1
					this.dialog = false
				})								
			},			

			querySelections (v) {
				this.loading = true
				console.log("Fetching Employees for Autocomplete")
				const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
				fetch("https://api.ba.arizona.edu/if/employees/" + v,
					{
							headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'apiEsriToken': apiEsriToken
							},
					})
					.then(response => response.json())
					.then(data => { 
						this.items = data 
						this.loading = false
					})
			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forms/AddPI.vue